import React, { PropsWithChildren } from 'react';
import { FlatCard } from '@/components/FlatCard';
import theme from './PrimaryCard.module.scss';

interface DataRowProps extends PropsWithChildren {
    label: string;
}

const isEmptyValue = (children: React.ReactNode) => children == null || children === '' || children === false;

export const DataRow: React.FC<DataRowProps> = ({ label, children }) => {
    return (
        <>
            <dt>{label}</dt>
            <dd>{isEmptyValue(children) ? <span className={theme.empty}>—</span> : children}</dd>
        </>
    );
};

interface PrimaryCardProps {
    loading?: boolean;
    title?: string;
    /** Rendered on the right side of the header row (e.g. an Edit button). */
    actions?: React.ReactNode;
    className?: string;
    children?: React.ReactNode | (() => React.ReactNode);
}

/** A FlatCard whose content is label/value rows (PrimaryCard.Row). */
const PrimaryCard: React.FC<PrimaryCardProps> = ({ loading, children, title, actions, className }) => {
    return (
        <FlatCard title={title} actions={actions} loading={loading} className={className}>
            {() => <dl className={theme.rows}>{typeof children === 'function' ? children() : children}</dl>}
        </FlatCard>
    );
};

export default PrimaryCard;
